import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CopyService } from '../../services/copies/copy.service';
import { HelpersService } from '../../services/helpers/helpers-onboarding.service';
import { NavigationService } from '../../services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../services/tagging/tagging.service';
import { BitacoraService } from '../../services/bitacora/bitacora.service';
import { AbreCuentasService } from '../../services/abre-cuentas/abre-cuentas.service';
import { navCode } from '../../constants/channel.constants';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-controls',
  templateUrl: './controls-onboarding.component.html',
  styleUrls: ['./controls-onboarding.component.scss'],
})

/**
 * Componente de control para las acciones vovler y continuar
 *
 * *This component has previous and next controls*
 */
export class ControlsComponent {
  /**
   * Input que valida si se mostrara el boton atrás o no
   *
   * *Validates if previous button is shown*
   * @access public
   * @type {boolean}
   */
  @Input() hasPrevious = false;

  /**
   * Input que valida si se mostrara el boton atrás o no
   *
   * *Validates if previous button is shown*
   * @access public
   * @type {boolean}
   */
  @Input() hasNext = true;
  @Input() back = '';

  /**
   * Contiene el titulo del botón continuar
   *
   * *Has next button label*
   * @access public
   * @type {string}
   */
  @Input() nextLabel = 'Continuar';

  /**
   * Valida si el botón continuar esta desahabilitado o no
   *
   * *Validates if next buttons is disabled or not*
   */
  @Input() nextDisabled = false;

  /**
   * Contiene el titulo del botón volver
   *
   * *Has previous button label*
   * @access public
   * @type {string}
   */
  @Input() previousLabel;

  /**
   * Evento que se emite cuando se hace clic en continuar
   *
   * *Event that is emmitted when it does a click on next*
   */
  @Output() next = new EventEmitter<any>();

  /**
   * Evento que se emite cuando se hace clic en previous
   *
   * *Event that is emmitted when it does a click on previous*
   */
  @Output() previous = new EventEmitter<any>();

  /**
   * Evento que se emite cuando se hace clic en previous normal
   *
   * *Event that is emmitted when it does a click on normal previous*
   */
  @Output() only_previous = new EventEmitter<any>();

  /**
   * Constructor de la clase ControlsComponent
   *
   * *ControlsComponent constructor class*
   * @param navigationService
   * @param copyService
   */
  constructor(
    public navigationService: NavigationService,
    public copyService: CopyService,
    public taggingService: TaggingService,
    public helper: HelpersService,
    private bitacoraService: BitacoraService,
    private abreCuentasService: AbreCuentasService,
  ) {

  }

  /**
   * Ejecuta el metodo previousStep de NavigationService
   *
   * *Executes previousStep function from NavigationService*
   */
  onPrevious() {
    this.only_previous.emit(true);
    this.bitacoraService.saveDataInBitacora('return');
    if (this.navigationService.getCurrentStep().key === 'outlay-selection') {
      this.abreCuentasService.setOutlaySelection(undefined);
      this.abreCuentasService.setPassScreenCity(navCode[0]);
    }
    if (this.back == '') {
      this.navigationService.previousStep();
    } else {
      this.navigationService.previousStepMulti(this.back);
    }
  }

  /**
   * Ejecuta la función especificada
   *
   * *Emits a speficied function*
   */
  onPreviousError() {
    this.previous.emit(true);
    this.bitacoraService.saveDataInBitacora('return');
  }

  /**
   * Ejecuta la función especificada
   *
   * *Emits a speficied function*
   */
  onNext() {
    this.next.emit(true);
  }

  /**
   * Función de casos para los alerts
   *
   * *Cases function for alerts*
   */
  clickCustomTwoLink(event: any) {
    const optionSelected = this.copyService.copies.controls_return_button;
    switch (event.type) {
      case 'action1':
        this.pageTagEvent('11', optionSelected.action1);
        this.navigationService.goToLoginPage();
        break;
      case 'action2':
        this.pageTagEvent('11', optionSelected.action2);
        break;
    }
    this.navigationService.loadCustomScreen = false;
  }

  /**
   * Servicio para enviar datos a Google analytics
   *
   * *Send data to Google Analytics*
   */
  pageTagEvent(eventNumber: string, label?: string) {
    console.log(eventNumber, label);
    /* const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].path,
          value: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].value,
        },
        {
          path:
            EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].path,
          value:
            EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].value,
        },
      ];
      const category = label ? {
        module: 'lightbox',
        type: 'image',
        position: 'center',
      } :
      {
        module: 'header',
        type: 'button',
        position: 'top',
      };
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module[category.module],
          type: EVENT.customCategory.type[category.type],
          position: EVENT.customCategory.position[category.position],
        },
        action: EVENT.customAction.click,
        label: label ? label : EVENT[`${tagPageName}E${eventNumber}customLabel`],
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    } */
  }
}
